import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getExploreUnknownSurfaceFirstMissionPreviewUrl } from './config/exploreUnknownMissionBattle';
import './ExploreUnknownSkipWorldDialog.css';

/**
 * @param {object} props
 * @param {string} props.proceedSurface
 * @param {string} props.skipTargetSurface
 * @param {string} props.proceedMapName
 * @param {string} props.skipTargetMapName
 * @param {boolean} props.busy
 * @param {(choice: 'proceed' | 'skip') => void} props.onChoose
 */
export default function ExploreUnknownSkipWorldDialog({
  proceedSurface,
  skipTargetSurface,
  proceedMapName,
  skipTargetMapName,
  busy,
  onChoose,
}) {
  const { t } = useTranslation();

  const proceedImageUrl = useMemo(
    () => getExploreUnknownSurfaceFirstMissionPreviewUrl(proceedSurface),
    [proceedSurface]
  );
  const skipTargetImageUrl = useMemo(
    () => getExploreUnknownSurfaceFirstMissionPreviewUrl(skipTargetSurface),
    [skipTargetSurface]
  );

  return (
    <div className="explore-unknown-skip-world-overlay" role="dialog" aria-modal="true">
      <div className="explore-unknown-skip-world-dialog">
        <h2>{t('exploreUnknownPage.skipWorld.title')}</h2>
        <p>{t('exploreUnknownPage.skipWorld.body')}</p>
        <div className="explore-unknown-skip-world-actions">
          <button
            type="button"
            className="explore-unknown-skip-world-choice"
            disabled={busy}
            aria-label={t('exploreUnknownPage.skipWorld.proceedAria', { mapName: proceedMapName })}
            onClick={() => onChoose('proceed')}
          >
            <span className="explore-unknown-skip-world-choice-art">
              <img
                src={proceedImageUrl}
                alt=""
                onError={() => {
                  throw new Error(
                    `Explore Unknown skip-world preview failed to load (${proceedImageUrl})`
                  );
                }}
              />
            </span>
            <span className="explore-unknown-skip-world-choice-label">{proceedMapName}</span>
          </button>
          <button
            type="button"
            className="explore-unknown-skip-world-choice"
            disabled={busy}
            aria-label={t('exploreUnknownPage.skipWorld.skipAria', { mapName: skipTargetMapName })}
            onClick={() => onChoose('skip')}
          >
            <span className="explore-unknown-skip-world-choice-art">
              <img
                src={skipTargetImageUrl}
                alt=""
                onError={() => {
                  throw new Error(
                    `Explore Unknown skip-world preview failed to load (${skipTargetImageUrl})`
                  );
                }}
              />
            </span>
            <span className="explore-unknown-skip-world-choice-label">{skipTargetMapName}</span>
          </button>
        </div>
        <p className="explore-unknown-skip-world-hint">{t('exploreUnknownPage.skipWorld.hint')}</p>
      </div>
    </div>
  );
}
